import { StateType } from 'data/types'

import { Bank, BankState } from './types'

const getState = (state: StateType) => state.payments.bankTransfer

const isComplete = (bank: Bank) =>
  bank.state === BankState.ACTIVE || bank.state === BankState.REQUIRES_UPDATE
export const getActiveBanks = (state: StateType) => getState(state).banks.filter(isComplete)

export const isFetchingBanks = (state: StateType) => getState(state).fetching

export const getNewLinkedBank = (state: StateType) => getState(state).newLinkedBank

export const getBank = (state: StateType) => (id: string) => getState(state).byId[id]?.bank

export const getBankError = (state: StateType) => (id: string) => getState(state).byId[id]?.error

export const getBankSettlement = (state: StateType) => getState(state).bankSettlement
